<template>
  <div class="label-container">
    <div class="label-container-text">
      <slot />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.label-container {
  box-sizing: border-box;
  border: 1px solid #4a89dc;
  border-radius: 2px;
  background-color: #4a89dc;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 8px;
  display: inline-block;

  &-text {
    color: #ffffff;
    font-size: 12px;
    line-height: 18px;
  }
}
</style>
